import { useBreakpointV2 } from "@tm/ui-widgets";
// import { Header as MMTHeader } from 'pwa-mmt-ui-header/ssr/header';
import { PARTNER } from "@tm/isomorphic-utils";
import dynamic from "next/dynamic";
import Router from "next/router";
import { LandingHeaderMobile } from "..";

const DynamicMMTHeader = dynamic<any>(
  () => import("pwa-mmt-ui-header/ssr/header").then((module) => module.Header),
  { ssr: true }
);
export interface MyPartnerHeaderProps {
  type?: "singleHeader" | "dualHeader";
  forceLogin?: boolean;
  activeModal?: "LOGIN";
  showMyBizFormSwitcher?: boolean;
  profile?: "PERSONAL" | "BUSINESS";
  displayLanguageDropdown?: boolean;
  selectedTabName?: "Flights" | "Hotels" | "Travel Insurance";
  displayCurrencyDropdown?: boolean;
  showMoreButton?: boolean;
  showLoginPersuasionSlider?: boolean;
  multiLingualData?: {
    "header.login.signup.for.best.prices"?: string;
    "header.promotional.discount"?: string;
    "header.new.custom.tag"?: string;
  };
  pokusExperiments?: {
    mypStandaloneInsurance?: boolean;
    mypartnerMima?: boolean;
    mypVisaCommon?: boolean;
    mypHolidaysCommon?: boolean;
  };
  onLogin?: () => void;
  onLoginFlowComplete?: () => void;
  onModalChange?: (modal: "LOGIN" | undefined) => void;
  myPartner?: boolean;
  globalConfig?: any;
  headerCommonData?: {
    loyaltyHeaderData?: any;
    walletHeaderData?: any;
    mobileCore?: any;
    userInfoData?: any;
  };
  commonsData?: {
    myPartnerHorizontalStripeData?: any;
  };
}

interface MyPartnerAuthProps {
  forceLogin?: boolean;
  headerProps?: MyPartnerHeaderProps;
  mobileTitle?: string;
  myOrders?: boolean;
  goToMyOrders?: () => void;
  displayWhiteHeader?: boolean;
  isMyBiz?: boolean;
  exitWebViewOnBack?: boolean;
}

export function MyPartnerInsuranceHeader({
  headerProps = {},
  mobileTitle = "",
  myOrders,
  goToMyOrders,
  displayWhiteHeader,
  isMyBiz,
  exitWebViewOnBack = false,
}: MyPartnerAuthProps) {
  const device = useBreakpointV2();
  let headerPropsWithDefaults: MyPartnerHeaderProps = {
    type: "singleHeader",
    forceLogin: false,
    activeModal: undefined,
    showMyBizFormSwitcher: true,
    profile: "PERSONAL",
    displayLanguageDropdown: false,
    selectedTabName: "Travel Insurance",
    displayCurrencyDropdown: false,
    onLogin: () => Router.reload(),
    onLoginFlowComplete: () => void 0,
    onModalChange: () => void 0,
    showMoreButton: false,
    showLoginPersuasionSlider: false,
    pokusExperiments: {
      mypStandaloneInsurance: true,
      mypartnerMima: true,
      mypVisaCommon: false,
      mypHolidaysCommon: false,
    },
    multiLingualData: {
      "header.login.signup.for.best.prices":
        "Please login to purchase your travel insurance",
      "header.promotional.discount": "Promo Cash",
      "header.new.custom.tag": "No KYC",
    },
    myPartner: true,
    globalConfig: null,
    headerCommonData: {
      loyaltyHeaderData: null,
      walletHeaderData: null,
      mobileCore: null,
      userInfoData: null,
    },
    ...headerProps,
  };
  if (headerPropsWithDefaults.type === "dualHeader") {
    headerPropsWithDefaults.showMoreButton = false;
  }
  if (headerPropsWithDefaults?.forceLogin) {
    headerPropsWithDefaults = {
      ...headerPropsWithDefaults,
      activeModal: "LOGIN",
    };
    return <DynamicMMTHeader {...headerPropsWithDefaults} />;
  }
  return isMyBiz && device === "lg" ? null : device === "lg" ? (
    <DynamicMMTHeader {...headerPropsWithDefaults} />
  ) : (
    <LandingHeaderMobile
      headerTitle={mobileTitle}
      myOrders={myOrders}
      goToMyOrders={goToMyOrders}
      displayWhiteHeader={displayWhiteHeader}
      partnerType={PARTNER.MMT}
      insuranceHeader
      exitWebViewOnBack={exitWebViewOnBack}
    ></LandingHeaderMobile>
  );
}
